import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-[#94A3B8]">
      <div className="max-w-3xl mx-auto px-6 py-20">
        {/* Back */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#38BDF8] hover:text-white transition-colors mb-10"
        >
          ← Back to Home
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Terms of Service</h1>
        <p className="text-sm text-[#64748B] mb-10">Last updated: May 29, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-semibold text-base mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using any service provided by Tyo Solution ("we", "our", "us") at
              tyosolution.com or its sub-domains, you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">2. Description of Services</h2>
            <p>
              Tyo Solution offers API-based digital automation tools including but not limited to:
              Invoice OCR, CV Scoring (ScoreMyCV), PDF processing, and Image Optimization. Services
              are provided on a credit-based or subscription model as described on our pricing page.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">3. Account Registration</h2>
            <p>
              You may be required to create an account to access certain features. You are
              responsible for maintaining the confidentiality of your credentials and for all
              activities that occur under your account. You must provide accurate and complete
              information when registering.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">4. Acceptable Use</h2>
            <p className="mb-2">You agree not to:</p>
            <ul className="list-disc list-inside space-y-1 text-[#64748B]">
              <li>Use our services for any unlawful purpose or in violation of any regulations.</li>
              <li>Attempt to gain unauthorized access to any system or network.</li>
              <li>Transmit malicious code, viruses, or disruptive data.</li>
              <li>Reverse-engineer, decompile, or resell our services without explicit permission.</li>
              <li>Abuse free-tier limits or circumvent usage restrictions.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">5. Credits and Payments</h2>
            <p>
              Credits purchased are non-transferable and valid only for the account they were
              purchased under. Credits do not expire unless otherwise stated. Payments are processed
              securely via our payment provider (Paddle). All prices are in USD unless stated otherwise.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">6. Intellectual Property</h2>
            <p>
              All content, trademarks, and technology provided by Tyo Solution remain our exclusive
              property. You retain ownership of any data or files you upload to our services. We do
              not claim any rights over your content.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">7. Data and Privacy</h2>
            <p>
              We handle your data as described in our{" "}
              <Link to="/privacy" className="text-[#38BDF8] hover:underline">Privacy Policy</Link>.
              For services such as Image Optimizer, uploaded files are processed in memory and never
              stored on our servers.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Tyo Solution shall not be liable for any
              indirect, incidental, special, or consequential damages arising from your use of our
              services. Our total liability shall not exceed the amount paid by you in the last
              30 days.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">9. Service Availability</h2>
            <p>
              We strive for high availability but do not guarantee uninterrupted service. We reserve
              the right to modify, suspend, or discontinue any service at any time with reasonable
              notice.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">10. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of our services after
              changes constitutes acceptance of the revised Terms. We will post the updated date at
              the top of this page.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">11. Contact</h2>
            <p>
              For questions about these Terms, contact us at{" "}
              <a href="mailto:hi@tyosolution.com" className="text-[#38BDF8] hover:underline">
                hi@tyosolution.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
